<script>
  export let name
  export let role
  export let imgSrc
  export let bio
  // export let blurb
</script>

<style>
/* .mw {
  min-width: 250px;
} */
@media (min-width: 1200px) {
  .container {
    width: 760px;
  }
}
</style>

<!-- Team item -->
<div class="container bg-white rounded shadow-sm mb-5 py-5 px-4">
  <div class="row col-md-12 mr">
  
      <div class="col-3 mr">
        <img 
          src={imgSrc} alt="" width="150" 
          class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"
        >
      </div>
      <div class="col-9 mr">
        <h5 class="mb-0">{name}</h5>
        <span class="text-muted">{role}</span>
        <p class="bio">{bio}</p>    
      </div>    
  </div>
</div>
